export default __webpack_public_path__ + "static/media/07.c44cf858.jpg";